import React from "react";

/**
 * Bottom-border underline tabs with a flamingo accent on the active tab — the app's standard
 * tab style (mirrors the developer Project Details tabs). Controlled.
 *
 * Props:
 *  - tabs:     [{ key, label, count? }]
 *  - active:   key of the active tab
 *  - onChange: (key) => void
 *  - className: extra classes for the tab bar
 */
const Tabs = ({ tabs = [], active, onChange, className = "" }) => (
  <div
    className={`flex items-center gap-1 overflow-x-auto bg-white border-b border-slate-200 rounded-t-2xl px-3 ${className}`}
    style={{ scrollbarWidth: "thin" }}
  >
    {tabs.map((tab) => {
      const isActive = active === tab.key;
      return (
        <button
          type="button"
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`shrink-0 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
            isActive
              ? "text-flamingo-700 border-flamingo-500"
              : "text-slate-600 border-transparent hover:text-slate-900 hover:border-slate-300"
          }`}
        >
          {tab.label}
          {tab.count != null && (
            <span
              className={`ml-2 rounded-full px-1.5 py-0.5 text-[11px] font-semibold ${
                isActive ? "bg-flamingo-100 text-flamingo-700" : "bg-slate-100 text-slate-500"
              }`}
            >
              {tab.count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default Tabs;
